import CrmApi from '../../../api/CrmApi';
import crmName from '../../filters/crm-name';
import HttpBuildQuery from '../../procedures/http-build-query';
import FiltersType from './listingFiltersTypesConstants';

export const INVOICE_FILTERS = [
  {
    key: 'fulltext',
    placeholder: 'Wpisz frazę do znalezienia',
    shortPlaceholder: 'Szukaj',
    badge: 'Szukana fraza:',
    testName: 'hub_filter_search',
    inputType: FiltersType.TEXT_SEARCH_TYPE,
    reset: async () => ({ value: '' }),
  },
  {
    key: '_issue_date',
    reset: async () => ({ value: { fromVal: null, toVal: null } }),
    placeholder: '',
    badge: 'Data wystawienia:',
    testName: 'test_filter_invoice_issue_date',
    inputType: FiltersType.RANGE_TYPE,
    htmlInputType: 'date',
  },
  {
    key: 'sale_date',
    reset: async () => ({ value: { fromVal: null, toVal: null } }),
    placeholder: '',
    badge: 'Data sprzedaży:',
    testName: 'test_filter_invoice_sale_date',
    inputType: FiltersType.RANGE_TYPE,
    htmlInputType: 'date',
  },
  {
    key: '_total_net_amount',
    reset: async () => ({ value: { fromVal: null, toVal: null } }),
    placeholder: '',
    badge: 'Kwota netto:',
    testName: 'test_filter_invoice_total_net_value',
    inputType: FiltersType.RANGE_TYPE,
    htmlInputType: 'number',
  },
  {
    key: '_total_gross_amount',
    reset: async () => ({ value: { fromVal: null, toVal: null } }),
    placeholder: '',
    badge: 'Kwota brutto:',
    testName: 'test_filter_invoice_total_gross_value',
    inputType: FiltersType.RANGE_TYPE,
    htmlInputType: 'number',
  },
  {
    key: '_dueDate',
    reset: async () => ({ value: { fromVal: null, toVal: null } }),
    placeholder: '',
    badge: 'Termin płatności:',
    testName: 'test_filter_invoice_due_date',
    inputType: FiltersType.RANGE_TYPE,
    htmlInputType: 'date',
  },
  {
    key: '_invoice_clients_multi',
    getItems: async () => {
      let { data } = await CrmApi.index(HttpBuildQuery({ list: true }));
      delete data.pagination;

      return Object.values(data)
        .map((item) => {
          return {
            value: item.client.person.company.original,
            label: `${ crmName(item) }`,
          };
        });
    },
    reset: async () => null,
    placeholder: 'Kontrahent',
    badge: 'Kontrahent:',
    testName: 'test_filter_invoice_client',
    inputType: FiltersType.MULTI_SELECT_TYPE,
  },
];
